// Privates local storage
const localStorageGetObject = key => JSON.parse(localStorage.getItem(key));
const localStorageSetItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const localStorageRemoveItem = key => localStorage.removeItem(key);
// Local Storage
export const lsGetAuthToken = () => localStorageGetObject('auth:token');
export const lsSetAuthToken = value => localStorageSetItem('auth:token', value);
export const lsRemoveAuthToken = () => {
  localStorageRemoveItem('auth:token');
};
export const createPaginationQuery = params => {
  let queryString = '';
  const keys = Object.keys(params);
  keys.forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      if (queryString === '') {
        queryString += `?${key}=${params[key]}`;
      } else {
        queryString += `&${key}=${params[key]}`;
      }
    }
  });
  return queryString;
};

export const paginationData = resp => {
  const objEmpty = {
    total: 0,
    offset: -1,
    limit: -1,
    sort: '',
    direction: 0,
    fields: null,
    Search: null
  };
  return resp.headers['x-pagination'] ? JSON.parse(resp.headers['x-pagination']) : objEmpty;
};

export const lsGetSelectedCommonFilters = filter => {
  const lsSelectedCommonFilters = localStorageGetObject('selected:common:filters');
  if (lsSelectedCommonFilters) {
    return lsSelectedCommonFilters[filter];
  }
  return null;
};
